import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ClienteService } from 'src/app/services/cliente.service';
import { SpinnerService } from 'src/app/services/spinner.service';
import { basicAlert } from '../../utils';

@Component({
  selector: 'app-md-ic-ubigeo-edt',
  templateUrl: './md-ic-ubigeo-edt.component.html',
  styleUrls: ['./md-ic-ubigeo-edt.component.css']
})
export class MdIcUbigeoEdtComponent implements OnInit {

  listaDepartamentos: any[] = []
  listaprovincias: any[] = []
  listadistritos: any[] = []

  public codigoUbigeo: any;

  public codDepart: any;
  public desDepartamento: string = '';
  public codProv: string = null;
  public desProvincia: string = '';
  public codDist: string = null;
  public desDistrito: string = '';

  disabledprov: boolean = true;
  disableddistr: boolean = true;
  public editar: boolean = false;

  constructor(
    private modalactiveService: NgbActiveModal,
    private spinnerService: SpinnerService,
    private clienteService: ClienteService,
  ) { }

  ngOnInit(): void {

    this.cargarDepartamentos(14);



  }

  _close() {
    this.modalactiveService.dismiss('canceling');
  }

  _ok() {




    let clasesUbigeo: any[] = [];

    let ubi1 = {};
    let ubi2 = {};
    let ubi3 = {};

    if (this.listaDepartamentos != null && this.listaDepartamentos.length > 0)
      this.listaDepartamentos.forEach(element => {
        if (element.codigo == this.codDepart) {
          this.desDepartamento = element.descri;
        }
      });

    if (this.listaprovincias != null && this.listaprovincias.length > 0)
      this.listaprovincias.forEach(element => {
        if (element.codigo == this.codProv) {
          this.desProvincia = element.provincia;
        }
      });

    if (this.listadistritos != null && this.listadistritos.length > 0)
      this.listadistritos.forEach(element => {
        if (element.codigo == this.codDist) {
          this.desDistrito = element.distrito;
        }
      });


    if (this.codDepart == undefined || this.codDepart == null
      || this.desDepartamento == undefined || this.desDepartamento == null || this.desDepartamento == "") {
      basicAlert("Departamento es requerido.", 'warning', 'Aceptar');
      return;
    }

    if (this.codProv == undefined || this.codProv == null
      || this.desProvincia == undefined || this.desProvincia == null || this.desProvincia == "") {
      basicAlert("Provincia es requerido.", 'warning', 'Aceptar');
      return;
    }

    if (this.codDist == undefined || this.codDist == null
      || this.desDistrito == undefined || this.desDistrito == null || this.desDistrito == "") {
      basicAlert("Distrito es requerido.", 'warning', 'Aceptar');
      return;
    }


    ubi1 = {
      clase: 14,
      desclase: 'DEPARTAMENTO',
      codigo: this.codDepart,
      descodigo: this.desDepartamento
    }

    ubi2 = {
      clase: 15,
      desclase: 'PROVINCIA',
      codigo: this.codProv,
      descodigo: this.desProvincia
    }

    ubi3 = {
      clase: 16,
      desclase: 'DISTRITO',
      codigo: this.codDist,
      descodigo: this.desDistrito
    }

    clasesUbigeo.push(ubi1);
    clasesUbigeo.push(ubi2);
    clasesUbigeo.push(ubi3);

    this.modalactiveService.close(clasesUbigeo);

  }

  onChangeDepartamento(valor: any) {
    this.spinnerService.activarLoading(true);
    this.clienteService.buscarUbigeos(valor).subscribe((resp: any) => {

      this.spinnerService.activarLoading(false);

      this.listaprovincias = resp.body.provincias;

      // if (this.codProv == null)
        this.codProv = this.listaprovincias[0].codigo;

      let distritos: any = null;
      this.listaprovincias.forEach(element => {
        if (element.codigo == this.codProv) {
          distritos = element.distritos;
        }
      });

      console.log(distritos);

      if (distritos == null)
        this.listadistritos = this.listaprovincias[0].distritos;
      else {
        this.listadistritos = distritos;
      }

      // if (this.codDist == null)
      this.codDist = this.listaprovincias[0].distritos[0].codigo;

      this.disabledprov = false;
      this.disableddistr = false;

        
    }, err => {
      this.spinnerService.activarLoading(false);
    })
  }

  onChangeProvincia(valor: any) {
    if (this.listaprovincias != null)
      this.listaprovincias.forEach(element => {
        if (element.codigo == valor) {
          this.listadistritos = element.distritos
          this.codDist = this.listadistritos[0].codigo
        }
      })
  }

  onChangeDistrito(valor: any) {
    this.codigoUbigeo = valor;
  }

  cargarDepartamentos(valor: any) {
    this.spinnerService.activarLoading(true);
    this.clienteService.buscarCodigos(valor).subscribe((resp: any) => {
      this.spinnerService.activarLoading(false);
      this.listaDepartamentos = resp.body;


      if (this.editar) {
        this.clienteService.buscarUbigeos(this.codDepart).subscribe((resp: any) => {
          this.spinnerService.activarLoading(false);
          this.listaprovincias = resp.body.provincias;
        
          let distritos: any = null;
          this.listaprovincias.forEach(element => {
            if (element.codigo == this.codProv) {
              distritos = element.distritos;
            }
          });
    
          console.log(distritos);
    
          if (distritos == null)
            this.listadistritos = this.listaprovincias[0].distritos;
          else {
            this.listadistritos = distritos;
          }
    
          this.disabledprov = false;
          this.disableddistr = false;
    
            
        }, err => {
          this.spinnerService.activarLoading(false);
        })      
      }



    }, err => {
      this.spinnerService.activarLoading(false);
    })
  }


  onKeyEnterProvincia(e) {
    if (this.codProv != null) {
      setTimeout(() => {
      }, 200);
    }

    let tecla: any;
    tecla = (document.all) ? e.keyCode : e.which;
    return (tecla != 13);
  }

  onBlurProvincia(e) {
    if (this.codProv != null) {
      if (e.which == 0) {
        if ($('#cboProvincia option:selected').text() == '') {
          //this.codProv = null;
          basicAlert('No existe el código ingresado.', 'warning', 'Aceptar', null, null, null);
          this.codProv = this.listaprovincias[0].codigo
          this.listaprovincias.forEach(element => {
            if (element.codigo == this.codProv) {
              this.listadistritos = element.distritos
              this.codDist = this.listadistritos[0].codigo
            }

            this.spinnerService.activarLoading(false);
          }, err => {
            this.spinnerService.activarLoading(false);
          })
        }
      }
    }
  }

  onKeyEnterDistrito(e) {
    if (this.codDist != null) {
      setTimeout(() => {
        // this.FuncionesTSI.validacionBusquedaPorCodigoInput(this.codSucursal.toString(), '#cboSucursal option:selected', 'El código de sucursal no existe', 'warning', '#codSucursal', '#codInterlocutor');
      }, 200);
    }

    let tecla: any;
    tecla = (document.all) ? e.keyCode : e.which;
    return (tecla != 13);
  }

  onBlurDistrito(e) {
    if (this.codDist != null) {
      if (e.which == 0) {
        //  this.FuncionesTSI.validacionBusquedaPorCodigoInput(this.codSucursal.toString(), '#cboSucursal option:selected', 'El código de sucursal no existe', 'warning', '#codSucursal', '#codInterlocutor');
        if ($('#cboDistrito option:selected').text() == '') {
          //his.codDist = null;
          basicAlert('No existe el código ingresado.', 'warning', 'Aceptar', null, null, null);
          this.codDist = this.listadistritos[0].codigo
        }
      }
    }
  }
  changeDepartamento(){
    this.codProv = "";
    this.codDist = "";
  }
}
